import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRuby = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.87304 3.26C5.94336 3.17852 6.03039 3.11312 6.12823 3.06826C6.22606 3.02339 6.33241 3.00012 6.44004 3H17.75C17.86 3.00004 17.9685 3.02425 18.0681 3.07091C18.1676 3.11756 18.2557 3.18553 18.326 3.27L23.326 9.27C23.443 9.41038 23.5047 9.58864 23.4996 9.77129C23.4944 9.95395 23.4228 10.1284 23.298 10.262L12.548 21.762C12.4779 21.8371 12.393 21.897 12.2988 21.9379C12.2045 21.9788 12.1028 21.9999 12 21.9999C11.8973 21.9999 11.7956 21.9788 11.7013 21.9379C11.6071 21.897 11.5222 21.8371 11.452 21.762L0.702041 10.262C0.575442 10.1268 0.503354 9.94952 0.499661 9.76434C0.495968 9.57915 0.560933 9.39915 0.682041 9.259L5.87204 3.259L5.87304 3.26ZM6.78304 4.5L2.25804 9.73L12 20.153L21.75 9.723L17.399 4.5H6.78304Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgRuby;
